
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as account0gZALsfIm0Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/account.vue?macro=true";
import { default as complete_45accountdUs62YnL6hMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/complete-account.vue?macro=true";
import { default as forgot_45passwordQ4DKK3GrZ2Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/forgot-password.vue?macro=true";
import { default as homesQ7AGUEWO1Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/home.vue?macro=true";
import { default as index1xjfnfjvBbMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/index.vue?macro=true";
import { default as loginEeb0npygf5Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/login.vue?macro=true";
import { default as notificationsgWzWSDpsXJMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/notifications.vue?macro=true";
import { default as reset_45passwordtinjwKTrpMMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/reset-password.vue?macro=true";
import { default as client_45filtersVLCM4BYrt7Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue?macro=true";
import { default as client_45groups2PGeQKkDxsMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue?macro=true";
import { default as _91id_93suNk5QXiQJMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue?macro=true";
import { default as indexNcmBNwAJ5yMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue?macro=true";
import { default as _91id_939AQBLSgbAxMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue?macro=true";
import { default as clientsa9Tw2iASB2Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue?macro=true";
import { default as delivery_45sheetsxmuzOYCMu5Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue?macro=true";
import { default as index8iSNFoutcAMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue?macro=true";
import { default as newm71C3BXnAKMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue?macro=true";
import { default as exportzGaAceNwacMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue?macro=true";
import { default as indexxoMofx1eYrMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue?macro=true";
import { default as newp15C2u07D2Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue?macro=true";
import { default as _91id_93a0mVeoOG3VMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue?macro=true";
import { default as importsVR6jN0JlvMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue?macro=true";
import { default as indexArZYxPkYKIMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue?macro=true";
import { default as createdo46wLl8GuMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue?macro=true";
import { default as _91id_93XTJVI0zJ9KMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue?macro=true";
import { default as _91id_93FzzTui6O6kMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue?macro=true";
import { default as indexFBWOoLO8XkMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue?macro=true";
import { default as inventorieskEYhTWCGUfMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue?macro=true";
import { default as inventoryZneLvlvuRbMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue?macro=true";
import { default as indexeMjnVkZxHCMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue?macro=true";
import { default as activitynYVONbdKZLMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue?macro=true";
import { default as burndown7g6yYQKnqqMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue?macro=true";
import { default as indexp0kTlrHYf8Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue?macro=true";
import { default as reportingOwiNFvv985Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue?macro=true";
import { default as _91id_93CZtDMDnt7WMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue?macro=true";
import { default as indexGTC0IGyr33Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue?macro=true";
import { default as appointments8HvkvxMSmWMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue?macro=true";
import { default as indexzEncZvPP1pMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue?macro=true";
import { default as _91id_93X6dvOPdzwqMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue?macro=true";
import { default as client_45assignmentWU2jSjpoUuMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue?macro=true";
import { default as client_45dashboardBq24o5muMIMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue?macro=true";
import { default as indexn9ri89F3WHMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue?macro=true";
import { default as _91id_935tguppPqQoMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue?macro=true";
import { default as collaboratorsl7N1Blz2GaMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue?macro=true";
import { default as indexEz58kbuCnmMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue?macro=true";
import { default as roadmapEzVkBnMYUYMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue?macro=true";
import { default as indexaAQJsWAJ9vMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue?macro=true";
import { default as tasksJCgA7wtTtdMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue?macro=true";
import { default as rolloutALFh7SDcshMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue?macro=true";
import { default as schedule_45appointmentE0v59InPPAMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/schedule-appointment.vue?macro=true";
import { default as brandingGas5PyeNF4Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/branding.vue?macro=true";
import { default as createPj1tJeshTpMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/checklists/create.vue?macro=true";
import { default as _91id_93xs3JXJQlvIMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/checklists/edit/[id].vue?macro=true";
import { default as indexwvFoc9Wnx3Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/checklists/index.vue?macro=true";
import { default as checklistsXhG285p65GMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/checklists.vue?macro=true";
import { default as client_45linksHseziyjw34Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/client-links.vue?macro=true";
import { default as custom_45fieldsr1GJtrnqvlMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/custom-fields.vue?macro=true";
import { default as indexDgDXbQyVh8Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/index.vue?macro=true";
import { default as integrationst94XYCmTG7Meta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/integrations.vue?macro=true";
import { default as rollouts3LB2CBkm0cMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/rollouts.vue?macro=true";
import { default as subscriptionGncIprYuBvMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/subscription.vue?macro=true";
import { default as usersXQTdfcnvGIMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/users.vue?macro=true";
import { default as creategtj9vGxEmZMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/workflows/create.vue?macro=true";
import { default as _91id_93KKV6cZbAIeMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/workflows/edit/[id].vue?macro=true";
import { default as indexJHKDFdoc2cMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/workflows/index.vue?macro=true";
import { default as workflows1YxLV9XhSVMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings/workflows.vue?macro=true";
import { default as settingsi7BpHtf4eOMeta } from "/codebuild/output/src137328735/src/packages/frontend/pages/settings.vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    meta: account0gZALsfIm0Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/account.vue")
  },
  {
    name: "complete-account",
    path: "/complete-account",
    meta: complete_45accountdUs62YnL6hMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/complete-account.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordQ4DKK3GrZ2Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/forgot-password.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homesQ7AGUEWO1Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index1xjfnfjvBbMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginEeb0npygf5Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/login.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsgWzWSDpsXJMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/notifications.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordtinjwKTrpMMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/reset-password.vue")
  },
  {
    name: inventoryZneLvlvuRbMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/inventory",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-filters",
    path: "client-filters",
    meta: client_45filtersVLCM4BYrt7Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-groups",
    path: "client-groups",
    meta: client_45groups2PGeQKkDxsMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue")
  },
  {
    name: clientsa9Tw2iASB2Meta?.name,
    path: "clients",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-delivery-sheet-id",
    path: "delivery-sheet/:id()",
    meta: _91id_93suNk5QXiQJMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients",
    path: "",
    meta: indexNcmBNwAJ5yMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-view-id",
    path: "view/:id()",
    meta: _91id_939AQBLSgbAxMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-delivery-sheets",
    path: "delivery-sheets",
    meta: delivery_45sheetsxmuzOYCMu5Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue")
  },
  {
    name: exportzGaAceNwacMeta?.name,
    path: "export",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-export",
    path: "",
    meta: index8iSNFoutcAMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-export-new",
    path: "new",
    meta: newm71C3BXnAKMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue")
  }
]
  },
  {
    name: importsVR6jN0JlvMeta?.name,
    path: "import",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-import",
    path: "",
    meta: indexxoMofx1eYrMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-new",
    path: "new",
    meta: newp15C2u07D2Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-view-id",
    path: "view/:id()",
    meta: _91id_93a0mVeoOG3VMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory",
    path: "",
    meta: indexArZYxPkYKIMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue")
  },
  {
    name: inventorieskEYhTWCGUfMeta?.name,
    path: "inventories",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-create",
    path: "create",
    meta: createdo46wLl8GuMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-dashboard-id",
    path: "dashboard/:id()",
    meta: _91id_93XTJVI0zJ9KMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-edit-id",
    path: "edit/:id()",
    meta: _91id_93FzzTui6O6kMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories",
    path: "",
    meta: indexFBWOoLO8XkMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue")
  }
]
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-knowledge-base",
    path: "/rollout-project/:rolloutIdentifier()/knowledge-base",
    meta: indexeMjnVkZxHCMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue")
  },
  {
    name: reportingOwiNFvv985Meta?.name,
    path: "/rollout-project/:rolloutIdentifier()/reporting",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-reporting-activity",
    path: "activity",
    meta: activitynYVONbdKZLMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting-burndown",
    path: "burndown",
    meta: burndown7g6yYQKnqqMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting",
    path: "",
    meta: indexp0kTlrHYf8Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue")
  }
]
  },
  {
    name: rolloutALFh7SDcshMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/rollout",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue"),
    children: [
  {
    name: appointments8HvkvxMSmWMeta?.name,
    path: "appointments",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments-id",
    path: ":id()",
    meta: _91id_93CZtDMDnt7WMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments",
    path: "",
    meta: indexGTC0IGyr33Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue")
  }
]
  },
  {
    name: client_45assignmentWU2jSjpoUuMeta?.name,
    path: "client-assignment",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment",
    path: "",
    meta: indexzEncZvPP1pMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment-inventory-id",
    path: "inventory/:id()",
    meta: _91id_93X6dvOPdzwqMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-dashboard",
    path: "client-dashboard",
    meta: client_45dashboardBq24o5muMIMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue")
  },
  {
    name: collaboratorsl7N1Blz2GaMeta?.name,
    path: "collaborators",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators",
    path: "",
    meta: indexn9ri89F3WHMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators-profile-id",
    path: "profile/:id()",
    meta: _91id_935tguppPqQoMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout",
    path: "",
    meta: indexEz58kbuCnmMeta || {},
    alias: ["/rollout-project/:rolloutIdentifier()"],
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-roadmap",
    path: "roadmap",
    meta: roadmapEzVkBnMYUYMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue")
  },
  {
    name: tasksJCgA7wtTtdMeta?.name,
    path: "tasks",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-tasks",
    path: "",
    meta: indexaAQJsWAJ9vMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue")
  }
]
  }
]
  },
  {
    name: "schedule-appointment",
    path: "/schedule-appointment",
    meta: schedule_45appointmentE0v59InPPAMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/schedule-appointment.vue")
  },
  {
    name: settingsi7BpHtf4eOMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-branding",
    path: "branding",
    meta: brandingGas5PyeNF4Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/branding.vue")
  },
  {
    name: checklistsXhG285p65GMeta?.name,
    path: "checklists",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/checklists.vue"),
    children: [
  {
    name: "settings-checklists-create",
    path: "create",
    meta: createPj1tJeshTpMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/checklists/create.vue")
  },
  {
    name: "settings-checklists-edit-id",
    path: "edit/:id()",
    meta: _91id_93xs3JXJQlvIMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/checklists/edit/[id].vue")
  },
  {
    name: "settings-checklists",
    path: "",
    meta: indexwvFoc9Wnx3Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/checklists/index.vue")
  }
]
  },
  {
    name: "settings-client-links",
    path: "client-links",
    meta: client_45linksHseziyjw34Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/client-links.vue")
  },
  {
    name: "settings-custom-fields",
    path: "custom-fields",
    meta: custom_45fieldsr1GJtrnqvlMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/custom-fields.vue")
  },
  {
    name: "settings",
    path: "",
    meta: indexDgDXbQyVh8Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    meta: integrationst94XYCmTG7Meta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-rollouts",
    path: "rollouts",
    meta: rollouts3LB2CBkm0cMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/rollouts.vue")
  },
  {
    name: "settings-subscription",
    path: "subscription",
    meta: subscriptionGncIprYuBvMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/subscription.vue")
  },
  {
    name: "settings-users",
    path: "users",
    meta: usersXQTdfcnvGIMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/users.vue")
  },
  {
    name: workflows1YxLV9XhSVMeta?.name,
    path: "workflows",
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/workflows.vue"),
    children: [
  {
    name: "settings-workflows-create",
    path: "create",
    meta: creategtj9vGxEmZMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/workflows/create.vue")
  },
  {
    name: "settings-workflows-edit-id",
    path: "edit/:id()",
    meta: _91id_93KKV6cZbAIeMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/workflows/edit/[id].vue")
  },
  {
    name: "settings-workflows",
    path: "",
    meta: indexJHKDFdoc2cMeta || {},
    component: () => import("/codebuild/output/src137328735/src/packages/frontend/pages/settings/workflows/index.vue")
  }
]
  }
]
  }
]